module.exports = __webpack_public_path__ + "img/“.a4eb2c40.svg";